export const ActionTypes = {
    SET_CURRENT_LOCATION: "app/redux/mgt-station/SET_CURRENT_LOCATION",
    SET_TEMP_FORM: "app/redux/mgt-station/SET_TEMP_FORM",
}